/*import { Contador } from "./components/Contador";
import "./App.css";

const App = () => {
  return <Contador inicial={5} factor={3} />;
};

export default App;
*/

import Cards from "./components/Cards";

const App = () => {
  return <Cards />;
};

export default App;
